export default{
  key: "account_vehicle",
  // trash: true,
  id: "acc_id",
  export: ["excel"],
  action: ["create","edit","delete"],
  sort_fields: [
    "acc_id",
    "cp_id",
    "car_reg_no",
    "cp_no"
  ],
  fields: [
    { key: "acc_id" },
    { key: "car_reg_no" },
    { key: "cp_no" },
    { key: "cp", field: "cp.cp_no", value: "cp.cp_id", type: "select" },
    { key: "monthly_charging_time", type: "s_to_hms" },
    { key: "monthly_charged_energy", type: "float", decimal_point: 3 },
    { key: "daily_charging_time", type: "s_to_hms" },
    { key: "daily_charged_energy", type: "float", decimal_point: 3 },
    { key: "rfid_cards", hidden: ["list"] },
    { key: "acc_status", field: "acc_status.name_chi", value: "acc_status.acc_status_code", type: "select" },
    { type: "action-btn", privilege: ["EDIT_ACCOUNT_VEHICLE"]}
  ],
  api: {
    // create: "accounts",
    // edit: "accounts",
    // view: "accounts"
  },
  filters: {
    acc_id: {},
    car_reg_no: {},
    cp_no: {},
    acc_status: {
      type: "select"
    }
  },
  options: {
    acc_status: {
      key: "account_statuses",
      label: "name_chi",
      value: "acc_status_code"
    },
    cp: {
      key: "cps",
      label: "cp_no",
      value: "cp_id",
    }
  },
  structure: [
    ["car_reg_no","cp"],
    ["rfid_cards"],
    ["acc_status"],
  ]
}